// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.letter-box[data-v-173d2630] {\r\n  width: 30px;\r\n  height: 30px;\r\n  line-height: 30px;\r\n  display: inline-block;\r\n  text-align: center;\r\n  color: white;\r\n  font-weight: bold;\n}\n[data-v-173d2630]\r\n  .custom-control-input:checked:disabled\r\n  ~ .custom-control-label::before {\r\n  background-color: #3f5b60 !important;\r\n  border-color: #3f5b60 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
